module.exports = "pegasus_template/assets/square-linkedin.gif";